import React from 'react';
import KickImage from 'Reuseables/KickImage';

import { ISearchItemsProps } from './SearchItems.definitions';

/** CSS import */
import Styles from './SearchItems.module.scss';

import ReactPlaceholder from 'react-placeholder';
import 'react-placeholder/lib/reactPlaceholder.css';
import { TextBlock, RectShape } from 'react-placeholder/lib/placeholders';
import SearchItem from '../SearchItem/SearchItem';
import moment from 'moment';
import { useGetViewType } from 'Pages/Home/Hooks/useGetViewType';
import { Link, useHistory } from 'react-router-dom';
import useFetchKeywordSearch from 'Pages/Blog/Hooks/useFetchKeywordSearch';

const SearchItems: React.FC<ISearchItemsProps> = ({
  data,
  isFetching,
  keyword,
  onClose,
  totalArticles,
}: ISearchItemsProps) => {
  const history = useHistory();
  const { isDesktopView } = useGetViewType();
  const Placeholder = React.useMemo(
    () => (
      <div className={Styles['placeholder']}>
        {Array.from({ length: isDesktopView ? 6 : 3 }).map((_, index) => (
          <div className={Styles['placeholder-item']}>
            <RectShape color="#eeeeee" style={{ width: '100%', height: 60 }} />
            <TextBlock rows={3} color="#eeeeee" />
          </div>
        ))}
      </div>
    ),
    [],
  );

  const navigateToSearchPage = (
    e: React.MouseEventHandler<HTMLAnchorElement>,
  ) => {
    e.preventDefault();
    onClose();
    history.push(`/kickavenews/search/${keyword}`);
  };

  return (
    <div className={Styles['wrapper']}>
      <div className={Styles['search-items']}>
        <ReactPlaceholder ready={!isFetching} customPlaceholder={Placeholder}>
          {data.map((item, index) => (
            <SearchItem
              key={`search-item-${item.slug}`}
              title={item.title}
              date={moment(item.created_at).format('MMMM DD, YYYY')}
              image={item.thumbnail?.URL ?? 'https://picsum.photos/500'}
              link={`/kickavenews/${item.slug}`}
              onClose={onClose}
            />
          ))}
        </ReactPlaceholder>
      </div>
      {!isFetching && (
        <div className={Styles['button-row']}>
          <a href="#" onClick={navigateToSearchPage}>
            <div className={Styles['more-button']}>
              <p>
                Browse all "<span className={Styles['bold']}>{keyword}</span>" (
                {totalArticles})
              </p>
            </div>
          </a>
        </div>
      )}
    </div>
  );
};

export default SearchItems;
